import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortName'
})
export class SortNamePipe implements PipeTransform {

  transform(array: any[], propertyName: string): any[] {
    if (!Array.isArray(array)) {
      return array;
    }

    return array.sort((a, b) => {
      const nameA = a[propertyName]?.toUpperCase() || '';
      const nameB = b[propertyName]?.toUpperCase() || '';

      return nameA.localeCompare(nameB);
    });
  }
}